module.exports = __webpack_public_path__ + "img/badge_incentive_toduba.0209ee9f.jpg";